import color from "../../../../../constants/color";

const style = {
  heading:{
    fontSize:"20px",
    fontWeight:"600",
    pl:2
  },
  checkinBtn:
  { borderRadius: 50, 
    backgroundColor: "#28AA4A",
    color: "#fff", 
    ml: "8px" ,
    textTransform: "none", 
    fontSize: "12px",
  },
  importStatementBtn: { 
    borderRadius: 50, 
    backgroundColor: color.secondary,
    color: "#fff", 
    ml: "8px" ,
    textTransform: "none", 
    fontSize: "13px",
    boxShadow:"none"
  },
  cardTitle:{
    fontSize:"18px",
    fontWeight:"600",
    color:color.text
  },
  viewIcon: {
    color: color.lightText,
    fontSize: "1.3rem",
    mx:1.4
  },
  TableHead: {
    color: color.lightText,
    fontWeight: "400",
    whiteSpace:"nowrap",
    py: 0.5
  },
  tableAlign: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center",
    mt:1
  },
  tableIcon: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center" ,
  },
  tableData: {
    borderBottom: 0, 
    whiteSpace:"nowrap",
    py: 0.9
  },
  gridContainer: {
    px:"15px",
    pt:"7px",
    py: 1,
    display: "flex",
    justifyContent:"space-between", 
    mt:2
  },
  gridbox: {
    // alignItems:"center",
    backgroundColor: color.card,
    borderRadius: "20px",
    p: 2,
    mb:{ xs:2, md: 2 ,lg: 0},
    justifyContent: "space-between",
    // textAlign: "end"
  },
  gridboxAttendance: {
    borderRadius: "20px",
    p: 2,
    mb:{ xs:2, md: 2 ,lg: 0},
    justifyContent: "space-between",
    // textAlign: "end"
  },
  reportHeading: {
    fontSize: "18px",
    fontWeight: "600",
    mb:2
  },
  greenDot:{
    backgroundColor:color.primary,
    height:"12px",
    width:"12px",
    borderRadius: "50%",
    mr:1,
    mt: "4px"
  },
  grayDot:{
    backgroundColor: "#D9D9D9",
    height:"12px",
    width:"12px",
    borderRadius: "50%",
    mr:1,
    mt: "4px"
  },
  purchase: {
    fontSize: "12px",
    fontWeight: "400",
  },
  graph: {
    " & svg" :{
      width: "100%"
    } 
  },
  reportGrid: {
    mt:1,
    display: "flex",
    justifyContent: "end",
    cursor: "pointer",
    "&:hover": {
      cursor: "pointer"
    },
  },
  reportText: {
    color: color.primary,
    fontWeight: "500",
    display: "flex"
  },
  modalGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    mb: 1,
    gap: "10px"
  },
  boxs2:{
    width:"100%",
    ml:0.5
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    my: 1,
  },
  inputBoxs: {
    width: { xs: "100%", md: "50%", lg: "50%"},
    ml: 1,
    backgroundColor: "black", // Add black background
    color: "white", // Ensure text is visible
    // padding: 2, // Add padding for better spacing
    borderRadius: 2,
    with:"100%"
  },
  inputTexts: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1,
    mb:1
  },
  calenderInput: {
    "& .MuiInputBase-root": {
      height: "41px", // or whatever your input height is
    },
    "& .MuiInputBase-input": {
      padding: "8px 14px",
      height: "41px", // sometimes needed for vertical alignment
      boxSizing: "border-box",
      fontSize: "16px", // match your other inputs
    },
    width: "100%",
  },
};
export default style